import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Alert, scrollIntoView as scrollIntoViewFn,
} from '@printdeal/ui-library';

const ComplaintCreationError = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      scrollIntoViewFn(ref.current, {
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }, []);

  return (
    <Alert variant="error" ref={ref} className="pd-mb-4 pd-scroll-m-24">
      <FormattedMessage id="complaints.form.error" defaultMessage="Something went wrong while creating complaint." />
    </Alert>
  );
};

export default ComplaintCreationError;
